import { AccordionItemState, MortgageCalculationState } from '@hb/domain';

import { inject, Injectable } from '@angular/core';

import { ApPersistenceService } from '@ap/persistence';

@Injectable({
    providedIn: 'root'
})
export class StateService {
    private readonly persistenceService = inject(ApPersistenceService);

    private readonly sessionKey: string = 'mb';

    get(): MortgageCalculationState {
        return this.persistenceService.getSession(this.sessionKey, this.sessionKey);
    }

    set(mortgageCalculationState: MortgageCalculationState): void {
        this.persistenceService.setSession(this.sessionKey, this.sessionKey, mortgageCalculationState);
    }

    setAccordionState(stepStates: AccordionItemState[]) {
        this.persistenceService.setSession(this.sessionKey, 'steps', stepStates);
    }

    getAccordionState(): AccordionItemState[] {
        return this.persistenceService.getSession(this.sessionKey, 'steps');
    }
}
